const types = {
  TRANSACTION_ADD: "TRANSACTION_ADD",
  TRANSACTION_EDIT: "TRANSACTION_EDIT",
  TRANSACTION_DELETE: "TRANSACTION_DELETE",
  SET_CURRENT_RECORD: "SET_CURRENT_RECORD",
};

export default types;